import { createFileRoute } from '@tanstack/react-router'
import { AddressbookSection, addressbookLoader } from '@spcc/domains/addressbook'

export const Route = createFileRoute('/addressbook')({
  loader: addressbookLoader,
  component: AddressBookPage,
})

function AddressBookPage() {
  return <AddressbookSection />
}
